import React from "react";
import { Marker, OverlayView, Polygon } from "@react-google-maps/api";
import { ArcZonePolygonProps } from "./types";
import { getPolygonCenter, ZoneType } from "@src/core/features";
import { ZoneTypeMarkerColor } from "@src/features/zones/config/zones-constants";

const ArcZonePolygon: React.FC<ArcZonePolygonProps> = ({
  path,
  label,
  type,
  position,
  showMarkerIcon = false,
  onClick,
  ...rest
}) => {
  const color = ZoneTypeMarkerColor[type || ZoneType.TEMPORARY];

  const svg = encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
      <defs>
        <filter id="pinShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="black" flood-opacity="0.55"/>
        </filter>
      </defs>
      <path fill="${color}" filter="url(#pinShadow)"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5
           c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
    </svg>
  `);

  const icon = {
    url: `data:image/svg+xml;charset=UTF-8,${svg}`,
    scaledSize: new window.google.maps.Size(36, 36),
    anchor: new window.google.maps.Point(18, 36),
  };

  const markerPosition = position ?? getPolygonCenter(path);

  const labelTransform = showMarkerIcon
    ? "translate(-50%, 1px)" // below the pin
    : "translate(-50%, -50%)"; // centered inside polygon

  return (
    <>
      {showMarkerIcon && <Marker {...rest} icon={icon} position={markerPosition} onClick={onClick} />}

      <Polygon
        paths={path}
        options={{
          strokeColor: color,
          strokeWeight: 1,
          fillColor: color,
          fillOpacity: 0.3,
          clickable: true,
          editable: false,
        }}
      />

      {label && markerPosition && (
        <OverlayView
          position={markerPosition}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div
            style={{
              position: "absolute",
              transform: labelTransform,
              fontFamily: "Roboto, sans-serif",
              fontSize: "15px",
              fontWeight: "500",
              color: "#FFFFFF",
              pointerEvents: "none",
              whiteSpace: "nowrap",
              userSelect: "none",
              textAlign: "center",
              textShadow: `
                -1.2px -1.2px 0 #000,
                 1.2px -1.2px 0 #000,
                -1.2px  1.2px 0 #000,
                 1.2px  1.2px 0 #000,
                 0px    1.2px 0 #000,
                 0px   -1.2px 0 #000,
                 1.2px  0px  0 #000,
                -1.2px  0px  0 #000
              `,
            }}
          >
            {label}
          </div>
        </OverlayView>
      )}
    </>
  );
};

export default ArcZonePolygon;
